// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import {
  initializeFirestore,
  memoryLocalCache,
} from "firebase/firestore";
import { getFirestore as getLiteFirestore } from "firebase/firestore/lite";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";
import { getAuth } from "firebase/auth";
import { getPerformance } from "firebase/performance";


// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

if (!firebaseConfig.apiKey || !firebaseConfig.projectId || !firebaseConfig.appId) {
  throw new Error(
    "Missing Firebase environment variables. Set REACT_APP_FIREBASE_* values in your .env file."
  );
}

// Initialize Firebase
export const app = initializeApp(firebaseConfig);


// Initialize Performance Monitoring and get a reference to the service
export const perf = getPerformance(app);

perf.dataCollectionEnabled = true;

// No Firestore IndexedDB persistence — avoids Safari hangs on small queries.
// Login session on refresh / inactivity is handled by Auth + browserSession /
// SessionResumeGuard / InactivityTimer, not by this cache.
let firestoreInstance;
try {
  firestoreInstance = initializeFirestore(app, {
    localCache: memoryLocalCache(),
    experimentalAutoDetectLongPolling: true,
  });
} catch (err) {
  console.warn("Firestore init failed, falling back to getFirestore:", err);
  // eslint-disable-next-line global-require
  const { getFirestore } = require("firebase/firestore");
  firestoreInstance = getFirestore(app);
}

export const db = firestoreInstance;
/** One-shot REST reads — does not wait on the full SDK Listen stream (~22s recovery). */
export const dbLite = getLiteFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);
export const auth = getAuth(app);

export default db;
